import { Map, List, fromJS } from 'immutable'

/**
 * List
 */

export function organizationsLoading(state = false, action) {
  switch (action.type) {
    case 'ORGANIZATIONS_FETCH_LOADING':
      return action.isLoading
    case 'ORGANIZATIONS_FETCH_SUCCESS':
    case 'ORGANIZATIONS_FETCH_ERROR':
      return false
    default:
      return state
  }
}

export function organizationsError(state = false, action) {
  switch (action.type) {
    case 'ORGANIZATIONS_FETCH_ERROR':
      return action.hasErrored
    default:
      return state
  }
}

export function organizations(state = false, action) {
  switch (action.type) {
    case 'ORGANIZATIONS_FETCH_SUCCESS':
      return fromJS(action.items || [])
    case 'ORGANIZATION_CREATE_SUCCESS':
      return List.isList(state) ? state.push(fromJS(action.item)) : state
    case 'ORGANIZATION_UPDATE_SUCCESS':
      return !List.isList(state)
        ? state
        : state.map(org => (org.get('id') === action.item.id ? fromJS(action.item) : org))
    default:
      return state
  }
}

/**
 * Active organization
 */

export function activeOrganization(state = false, action) {
  switch (action.type) {
    case 'ORGANIZATION_FETCH_ITEM_RESET':
      return false

    case 'ORGANIZATION_FETCH_ITEM_SUCCESS':
      return fromJS(action.item)

    case 'ORGANIZATION_UPDATE_SUCCESS':
      let current = state || Map()
      let updated = fromJS(action.item)
      return current.merge(updated)

    default:
      return state
  }
}

export function activeOrganizationLoading(state = true, action) {
  switch (action.type) {
    case 'ORGANIZATION_FETCH_ITEM_LOADING':
      return action.isLoading
    case 'ORGANIZATION_FETCH_ITEM_SUCCESS':
      return false
    default:
      return state
  }
}

export function activeOrganizationError(state = false, action) {
  switch (action.type) {
    case 'ORGANIZATION_FETCH_ITEM_ERROR':
      return action.message
    default:
      return state
  }
}

/**
 * Create
 */

export function createOrganizationLoading(state = false, action) {
  switch (action.type) {
    case 'ORGANIZATION_CREATE_LOADING':
      return action.loading
    case 'ORGANIZATION_CREATE_SUCCESS':
    case 'ORGANIZATION_CREATE_FAIL':
      return false
    default:
      return state
  }
}

export function createOrganizationFail(state = false, action) {
  switch (action.type) {
    case 'ORGANIZATION_CREATE_FAIL':
      return action.message
    default:
      return state
  }
}

export function organizationCreating(state = false, action) {
  switch (action.type) {
    case 'ORGANIZATION_CREATE':
      return action.creating
    case 'ORGANIZATION_CREATE_SUCCESS':
      return false
    default:
      return state
  }
}

/**
 * User update
 */

export function updateOrganizationLoading(state = false, action) {
  switch (action.type) {
    case 'UPDATE_USER_LOADING':
      return action.loading
    default:
      return state
  }
}

export function updateOrganizationFail(state = false, action) {
  switch (action.type) {
    case 'UPDATE_USER_ERROR':
      return action.message
    default:
      return state
  }
}

/**
 * Contacts
 */

export function organizationContactCreating(state = false, action) {
  switch (action.type) {
    case 'ORGANIZATION_CREATE_CONTACT':
      return action.add || false
    case 'CONTACT_CREATE_SUCCESS':
      return false
    default:
      return state
  }
}

export function organizationContactEditing(state = false, action) {
  switch (action.type) {
    case 'ORGANIZATION_EDIT_CONTACT':
      return action.id || false
    case 'CONTACT_EDIT_SUCCESS':
      return false
    default:
      return state
  }
}

/**
 * Subsription renew status
 */

export function subscriptionRenewStatus(state = Map(), action) {
  if (action.type === 'SUBSCRIPTION_RENEW_STATUS_OPEN') return state.setIn([action.subscription_id, 'open'], true)

  if (action.type === 'SUBSCRIPTION_RENEW_STATUS_CLOSE') return state.setIn([action.subscription_id, 'open'], false)

  if (action.type === 'SUBSCRIPTION_RENEW_STATUS_LOADING') return state.setIn([action.subscription_id, 'loading'], true)

  if (action.type === 'SUBSCRIPTION_RENEW_STATUS_SUCCESS')
    return state.setIn([action.subscription_id, 'open'], false).setIn([action.subscription_id, 'loading'], false)

  if (action.type === 'SUBSCRIPTION_RENEW_STATUS_ERROR')
    return state
      .setIn([action.subscription_id, 'error'], action.message)
      .setIn([action.subscription_id, 'loading'], false)

  return state
}

/**
 * Subsription notification status
 */

export function subscriptionNotificationStatus(state = Map(), action) {
  if (action.type === 'SUBSCRIPTION_NOTIFICATION_STATUS_OPEN')
    return state.setIn([action.subscription_id, 'open'], true)

  if (action.type === 'SUBSCRIPTION_NOTIFICATION_STATUS_CLOSE')
    return state.setIn([action.subscription_id, 'open'], false)

  if (action.type === 'SUBSCRIPTION_NOTIFICATION_STATUS_LOADING')
    return state.setIn([action.subscription_id, 'loading'], true)

  if (action.type === 'SUBSCRIPTION_NOTIFICATION_STATUS_SUCCESS')
    return state.setIn([action.subscription_id, 'open'], false).setIn([action.subscription_id, 'loading'], false)

  if (action.type === 'SUBSCRIPTION_NOTIFICATION_STATUS_ERROR')
    return state
      .setIn([action.subscription_id, 'error'], action.message)
      .setIn([action.subscription_id, 'loading'], false)

  return state
}
